import React from "react";
import { Button, Label } from "reactstrap";

import { Icons } from "../Icon/Icon";

import style from "./RadioButton.scss";

export const RadioButton = ({ label, onClick, active, name }) => {
  const handleChangeDate = () => {
    onClick(name);
  };
  return (
    <Button onClick={handleChangeDate} className={style.radioButton}>
      {active ? (
        <Icons.RadioCheckedAnswer size="md" className={style.icon} />
      ) : (
        <Icons.RadioUncheckedIcon size="md" className={style.icon} />
      )}
      {label && <Label className={style.label}>{label}</Label>}
    </Button>
  );
};

export const RadioButtonGroup = ({ children }) => <div className={style.buttonGroup}>{children}</div>;
